<template>
  <div>
    <vue-phone-number-input v-model="phoneNumberEdit" @update="emitResult" no-use-browser-locale :translations="i18n" />
  </div>
</template>

<script>
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'

export default {
  name: 'Input-Phone',
  components: {
    VuePhoneNumberInput
  },
  props: {
    defaultCountryCode: {
      type: String,
      default: null
    },
    phoneNumber: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      phoneNumberEdit: '',
      i18n: {
        countrySelectorLabel: this.$gettext('Country Code'),
        countrySelectorError: this.$gettext('Select a country'),
        phoneNumberLabel: this.$gettext('Phone Number'),
        example: this.$gettext('Example:')
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (this.phoneNumber) {
        this.phoneNumberEdit = this.phoneNumber
      } else {
        this.$nextTick(() => {
          this.init()
        })
      }
    },
    emitResult($e) {
      if ($e.isValid) {
        this.$emit('update', $e.e164)
      } else if (!$e.isValid && !$e.e164) {
        this.$emit('update', '')
      }
    }
  }
}

</script>

<style lang="scss">
.vue-phone-number-input .select-country-container {
  width: auto !important;
  max-width: none !important;
}
.country-selector__country-flag {
  top: 18px !important;
}
.country-selector__input, .input-tel, .input-tel__input {
  height: 2.25rem !important;
  min-height: auto !important;
}
</style>
